import React from 'react'

function AIinNutrition() {
  return (
    <div>
      <h1>Research on AI in nutrition</h1>
      <h1>Coming soon.....</h1>
    </div>
  )
}

export default AIinNutrition
